export const shadows = {
    tiny: '0 1px 1px rgba(0, 0, 0, 0.11)',
    small: '0 1px 4px rgba(0, 0, 0, 0.05)',
    medium: '0 1px 1px rgba(0, 0, 0, 0.05), 0 4px 14px rgba(0, 0, 0, 0.08)',
};
